export { appInsights, initializeAppInsight } from "./Initialize"